(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsSoftenedWaterViewModel', facilityDetailsSoftenedWaterViewModelFactory);

  /** @ngInject */
  function facilityDetailsSoftenedWaterViewModelFactory(softenedWaterSubsystemUtils, modelUtils, subsystemService) {
    function FacilityDetailsSoftenedWaterViewModel(facilityPointJson) {

      var checkSubSystemStatus = -1;
      checkSubSystemStatus = subsystemService.check(facilityPointJson);

      this._propertyMappings = {};
      this._propertyMappings[softenedWaterSubsystemUtils.FeedReferences.OP_EMV_SPR_OMEKSANA_VODA] = 'vent';
      this._propertyMappings[softenedWaterSubsystemUtils.FeedReferences.OP_MAX_NIVO_OMEKS_VODE] = 'highFloat';
      this._propertyMappings[softenedWaterSubsystemUtils.FeedReferences.OP_MIN_NIVO_OMEKS_VODE] = 'lowFloat';
      this._propertyMappings[softenedWaterSubsystemUtils.FeedReferences.OP_CRPKA_OMEKS_VODE_RAD] = 'motor';
      this._propertyMappings[softenedWaterSubsystemUtils.FeedReferences.OP_CRPKA_OMEKS_VODE_GRE_MZS] = 'motorError';
      this._propertyMappings[softenedWaterSubsystemUtils.FeedReferences.OP_TLAK_OMEKSANE_VODE] = 'pressure';

      if (typeof facilityPointJson !== 'undefined' && checkSubSystemStatus > -1) {
        this.refresh(softenedWaterSubsystemUtils.getSoftenedWaterSubsystemPoint(facilityPointJson));
      }
    }

    FacilityDetailsSoftenedWaterViewModel.prototype.destroy = function () {

    };

    FacilityDetailsSoftenedWaterViewModel.prototype.refresh = function (softenedWaterPointJson) {
      this.pointId = softenedWaterPointJson.id;
      this.name = softenedWaterPointJson.name;
      this.pointType = softenedWaterPointJson.pointType;
      setFeedValue.call(this, softenedWaterSubsystemUtils.getFeed(softenedWaterPointJson, softenedWaterSubsystemUtils.FeedReferences.OP_EMV_SPR_OMEKSANA_VODA));
      setFeedValue.call(this, softenedWaterSubsystemUtils.getFeed(softenedWaterPointJson, softenedWaterSubsystemUtils.FeedReferences.OP_MAX_NIVO_OMEKS_VODE));
      setFeedValue.call(this, softenedWaterSubsystemUtils.getFeed(softenedWaterPointJson, softenedWaterSubsystemUtils.FeedReferences.OP_MIN_NIVO_OMEKS_VODE));
      setFeedValue.call(this, softenedWaterSubsystemUtils.getFeed(softenedWaterPointJson, softenedWaterSubsystemUtils.FeedReferences.OP_CRPKA_OMEKS_VODE_RAD));
      setFeedValue.call(this, softenedWaterSubsystemUtils.getFeed(softenedWaterPointJson, softenedWaterSubsystemUtils.FeedReferences.OP_CRPKA_OMEKS_VODE_GRE_MZS));
      setFeedValue.call(this, softenedWaterSubsystemUtils.getFeed(softenedWaterPointJson, softenedWaterSubsystemUtils.FeedReferences.OP_TLAK_OMEKSANE_VODE));
    };

    FacilityDetailsSoftenedWaterViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    return FacilityDetailsSoftenedWaterViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }
  }
})();
